import { useState, useEffect } from "react";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import { adminApi, setToken, getToken, clearToken, formatErr } from "@/lib/adminApi";
import AdminDashboard from "./AdminDashboard";

export default function Admin() {
  const [authed, setAuthed] = useState(null); // null=checking, true, false
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.title = "Admin · Tanonshop";
    if (!getToken()) { setAuthed(false); return; }
    adminApi.get("/auth/me").then(() => setAuthed(true)).catch(() => { clearToken(); setAuthed(false); });
  }, []);

  const login = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await adminApi.post("/auth/login", { email, password });
      setToken(data.access_token);
      setAuthed(true);
      toast.success(`Welcome back, ${data.user.name}`);
    } catch (err) {
      toast.error(formatErr(err));
    } finally { setLoading(false); }
  };

  const logout = () => { clearToken(); setAuthed(false); };

  if (authed === null) {
    return <div className="flex min-h-screen items-center justify-center bg-teal-anchor text-paper/70">Loading…</div>;
  }
  if (authed) return <AdminDashboard onLogout={logout} />;

  return (
    <div className="grain relative flex min-h-screen items-center justify-center bg-teal-anchor px-5">
      <form onSubmit={login} data-testid="admin-login-form" className="relative z-10 w-full max-w-sm rounded-sm bg-paper p-8 shadow-2xl">
        <div className="flex items-center gap-2 text-teal-primary"><Lock size={20} /><span className="text-xs font-semibold uppercase tracking-[0.2em]">Private area</span></div>
        <h1 className="mt-4 font-serif text-3xl tracking-tight text-teal-anchor">Tanonshop Admin</h1>
        <p className="mt-2 text-sm text-teal-anchor/60">Sign in to manage inquiries, quotes and orders.</p>
        <div className="mt-6 space-y-4">
          <input data-testid="admin-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" className="w-full rounded-sm border border-teal-anchor/20 bg-white px-4 py-3 text-sm outline-none focus:border-teal-primary" />
          <input data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" className="w-full rounded-sm border border-teal-anchor/20 bg-white px-4 py-3 text-sm outline-none focus:border-teal-primary" />
          <button data-testid="admin-login-btn" disabled={loading} className="w-full rounded-sm bg-teal-primary px-5 py-3 text-xs font-semibold uppercase tracking-[0.18em] text-paper transition-all hover:bg-teal-hover disabled:opacity-60">
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </div>
      </form>
    </div>
  );
}
